export const FileType = {
  image: 0,
  video: 1,
  document: 2,
};

// Uploads are grouped by MIME type; PDFs are the only documents claims accept.
export const getUploadFileTypeKey = (mimeType) => {
  if (mimeType === 'application/pdf') return 'document';
  return `${mimeType || ''}`.split('/')[0];
};

export const RepairItemType = {
  Item: 0,
  Labor: 1,
};
